import axios from './axios-instance'

const BASEURL = '/markets?'

export default {
  async get(counts = 0) {
    return axios.get(`${BASEURL}types=${counts}`)
  },
}
